// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CertificateDetailsTablet_root__TimmY section {
  margin: 16px 0 48px;
}
.CertificateDetailsTablet_root__TimmY .CertificateDetailsTablet_details__L\\+cUw {
  font-weight: 300;
  display: grid;
  padding: 24px;
  gap: 36px;
}
.CertificateDetailsTablet_root__TimmY .CertificateDetailsTablet_details__L\\+cUw > div {
  grid-column: span 2;
  line-height: 1.6;
}
.CertificateDetailsTablet_root__TimmY .CertificateDetailsTablet_details__L\\+cUw > div.CertificateDetailsTablet_title__CU54U {
  grid-column: span 4;
}
.CertificateDetailsTablet_root__TimmY .CertificateDetailsTablet_details__L\\+cUw > div.CertificateDetailsTablet_icon__\\+fd5B {
  grid-column: span 1;
}
.CertificateDetailsTablet_root__TimmY .CertificateDetailsTablet_details__L\\+cUw > div.CertificateDetailsTablet_createdBy__Gvr8k {
  grid-column: span 2;
  max-width: 150px;
}
.CertificateDetailsTablet_root__TimmY .CertificateDetailsTablet_details__L\\+cUw > div.CertificateDetailsTablet_createdBy__Gvr8k div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.CertificateDetailsTablet_root__TimmY .CertificateDetailsTablet_details__L\\+cUw > div.CertificateDetailsTablet_checkedBy__W-IEz {
  grid-column: 11/span 2;
}
.CertificateDetailsTablet_root__TimmY .CertificateDetailsTablet_details__L\\+cUw > div > :first-child {
  color: grey;
  margin-bottom: 8px;
  font-weight: 400;
}
.CertificateDetailsTablet_root__TimmY .CertificateDetailsTablet_joints__0MHUS .CertificateDetailsTablet_review__55Wld {
  text-align: end;
}
.CertificateDetailsTablet_root__TimmY .CertificateDetailsTablet_joints__0MHUS thead th:last-child {
  text-align: end;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/CertificateDetails/CertificateDetailsTablet.module.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AAEE;EACE,gBAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;AAAJ;AACI;EACE,mBAAA;EAoBA,gBAAA;AAlBN;AADM;EACE,mBAAA;AAGR;AADM;EACE,mBAAA;AAGR;AADM;EACE,mBAAA;EACA,gBAAA;AAGR;AAFQ;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAIV;AADM;EACE,sBAAA;AAGR;AAGM;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AADR;AAMI;EACE,eAAA;AAJN;AAMI;EACE,eAAA;AAJN","sourcesContent":[".root {\r\n  section {\r\n    margin: 16px 0 48px;\r\n  }\r\n  .details {\r\n    font-weight: 300;\r\n    display: grid;\r\n    padding: 24px;\r\n    gap: 36px;\r\n    > div {\r\n      grid-column: span 2;\r\n      &.title {\r\n        grid-column: span 4;\r\n      }\r\n      &.icon {\r\n        grid-column: span 1;\r\n      }\r\n      &.createdBy {\r\n        grid-column: span 2;\r\n        max-width: 150px;\r\n        div {\r\n          white-space: nowrap;\r\n          overflow: hidden;\r\n          text-overflow: ellipsis;\r\n        }\r\n      }\r\n      &.checkedBy {\r\n        grid-column: 11 / span 2;\r\n      }\r\n\r\n      line-height: 1.6;\r\n\r\n      // Header\r\n      > :first-child {\r\n        color: grey;\r\n        margin-bottom: 8px;\r\n        font-weight: 400;\r\n      }\r\n    }\r\n  }\r\n  .joints {\r\n    .review {\r\n      text-align: end;\r\n    }\r\n    thead th:last-child {\r\n      text-align: end;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CertificateDetailsTablet_root__TimmY`,
	"details": `CertificateDetailsTablet_details__L+cUw`,
	"title": `CertificateDetailsTablet_title__CU54U`,
	"icon": `CertificateDetailsTablet_icon__+fd5B`,
	"createdBy": `CertificateDetailsTablet_createdBy__Gvr8k`,
	"checkedBy": `CertificateDetailsTablet_checkedBy__W-IEz`,
	"joints": `CertificateDetailsTablet_joints__0MHUS`,
	"review": `CertificateDetailsTablet_review__55Wld`
};
export default ___CSS_LOADER_EXPORT___;
